<script lang="js">
export default {
  data() {
    return {
      socialLinks: {
        x: process.env.VUE_APP_FCP_X_URL || "",
        instagram: process.env.VUE_APP_FCP_INSTAGRAM_URL || "",
        facebook: process.env.VUE_APP_FCP_FACEBOOK_URL || "",
      },
    };
  },
};
</script>
<template>
  <div class="container-fluid px-5 fcp-bg-secondary text-white">
    <footer class="py-5">
      <div class="row">
        <div class="col-6 col-md-2 mb-3">
          <h6 class="text-white">Section</h6>
          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <RouterLink class="nav-link p-0 text-secondary link-info" to="/"
                >Home</RouterLink
              >
            </li>
            <li class="nav-item mb-2">
              <RouterLink
                class="nav-link p-0 text-secondary link-info"
                to="/about"
                >About</RouterLink
              >
            </li>
            <li class="nav-item mb-2">
              <RouterLink
                to="/app"
                class="nav-link p-0 text-secondary link-info"
              >
                Admissions
              </RouterLink>
            </li>
            <li class="nav-item mb-2">
              <a
                class="nav-link p-0 text-secondary link-info"
                target="_blank"
                href=" https://www.oxygist.com.ng/2024/08/first-city-polytechnic-berths-in.html"
                >News</a
              >
            </li>
            <li class="nav-item mb-2">
              <RouterLink
                class="nav-link p-0 text-secondary link-info"
                to="/contact"
              >
                Contact
              </RouterLink>
            </li>
          </ul>
        </div>
        <div class="col-6 col-md-2 mb-3">
          <h6 class="text-white">Quick Links</h6>
          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <RouterLink
                :to="$urlHelper.getApplyPath()"
                class="nav-link p-0 text-secondary link-info"
              >
                Online Application
              </RouterLink>
            </li>
            <li class="nav-item mb-2">
              <a
                @click="$urlHelper.goToPortal('/')"
                class="nav-link p-0 text-secondary link-info"
                style="cursor: pointer"
              >
                Student Portal
              </a>
            </li>
            <li class="nav-item mb-2">
              <a
                @click="$urlHelper.goToStaff('/')"
                class="nav-link p-0 text-secondary link-info"
                style="cursor: pointer"
              >
                Staff
              </a>
            </li>
            <li class="nav-item mb-2">
              <a href="" class="nav-link p-0 text-secondary link-info">Agent</a>
            </li>
            <li class="nav-item mb-2">
              <a href="#" class="nav-link p-0 text-secondary link-info">FAQs</a>
            </li>
          </ul>
        </div>
        <div class="col-6 col-md-3 mb-3">
          <h6 class="text-white">Information</h6>
          <ul class="nav flex-column">
            <li class="nav-item mb-2 text-secondary">
              phone:
              <a
                class="text-decoration-none text-secondary link-info"
                href="tel:+2347063377322"
                >+234 (0) 706 337 7322</a
              >
            </li>
            <li class="nav-item mb-2 text-secondary">
              email:
              <a
                href="mailto:info@firstcitypoly.edu.ng"
                class="text-decoration-none text-secondary link-info"
                >info@firstcitypoly.edu.ng</a
              >
              or
              <a
                class="text-decoration-none text-secondary link-info"
                href="mailto:registrar@firstcitypoly.edu.ng"
                >registrar@firstcitypoly.edu.ng</a
              >
            </li>
          </ul>
        </div>

        <div class="col-md-4 offset-md-1 mb-3">
          <form class="mb-4">
            <h6>Subscribe to our newsletter</h6>
            <p class="text-secondary">
              Monthly digest of what's new and exciting from us.
            </p>
            <div class="d-flex flex-column flex-sm-row w-100 gap-2">
              <label for="newsletter1" class="visually-hidden"
                >Email address</label
              >
              <input
                id="newsletter1"
                type="text"
                class="form-control"
                placeholder="Email address"
              />
              <button class="btn btn-outline-primary" type="button">
                Subscribe
              </button>
            </div>
          </form>
          <ul class="list-unstyled d-flex justify-content-start gap-4">
            <li class="me-3">
              <a
                class="text-secondary link-info"
                :href="socialLinks.facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="bi bi-facebook fs-5"></i>
              </a>
            </li>

            <li class="me-3">
              <a
                class="text-secondary link-info"
                :href="socialLinks.instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="bi bi-instagram fs-5"></i>
              </a>
            </li>

            <li class="me-3">
              <a
                class="text-secondary link-info"
                :href="socialLinks.x"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i class="bi bi-twitter-x fs-5"></i>
              </a>
            </li>
            <li class="">
              <i class="bi bi-whatsapp text-secondary link-info fs-5"></i>
            </li>
          </ul>
        </div>
      </div>

      <div
        style="border-width: 0.5px !important"
        class="containe-fluid border-top border-secondary mt-5"
      >
        <div class="row mt-3 g-3">
          <div class="col-md-4">
            <p class="small text-secondary text-md-start mb-0">
              &copy; {{ new Date().getFullYear() }} First City Polytechnic. All
              rights reserved.
            </p>
          </div>

          <div class="col-md-4 text-center">
            <p
              class="small text-secondary d-inline-flex align-items-center mb-0"
            >
              <img
                class="me-2"
                height="25"
                src="../../assets/img/rootlab-grey.svg"
                alt=""
              />
              Powered by
              <a
                href="https://rootlab.africa"
                target="_blank"
                class="text-decoration-none text-secondary text-decoration-underline link-info d-inline-flex align-items-center ms-1"
              >
                rootlab
              </a>
            </p>
          </div>

          <div class="small col-md-4 text-md-end">
            <RouterLink
              to="/privacy"
              class="me-4 text-decoration-none text-secondary link-info"
              >Privacy Policy
            </RouterLink>

            <RouterLink
              to="/terms"
              class="text-decoration-none text-secondary link-info"
              >Terms and Conditions
            </RouterLink>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<style scoped></style>
